import type { Icon } from "@phosphor-icons/react";
import {
  CalendarIcon,
  ChatCircleTextIcon,
  FileTextIcon,
  HeadsetIcon,
  NotepadIcon,
  PlugsConnectedIcon,
  PlugsIcon,
  QuestionIcon,
  TrayIcon,
} from "@phosphor-icons/react";

// Icon mapping for specific tool names (takes priority)
const TOOL_NAME_ICONS: Record<string, Icon> = {
  booking: CalendarIcon,
  qualifications: NotepadIcon,
  basic_tools: HeadsetIcon,
  custom_api: PlugsIcon,
  mcp: PlugsConnectedIcon,
  post_call_sms: ChatCircleTextIcon,
  faq: QuestionIcon,
  messages: TrayIcon,
};

// Default icon for tools without a specific mapping
const DEFAULT_ICON = FileTextIcon;

interface ToolIconProps {
  toolName: string;
  className?: string;
  weight?: "thin" | "light" | "regular" | "bold" | "fill" | "duotone";
}

/**
 * Get the icon component for a tool by its name
 */
export function getToolIcon(toolName: string): Icon {
  return TOOL_NAME_ICONS[toolName] || DEFAULT_ICON;
}

/**
 * ToolIcon component - displays the appropriate icon for a tool
 */
export function ToolIcon({
  toolName,
  className,
  weight = "fill",
}: ToolIconProps) {
  const Icon = getToolIcon(toolName);
  return <Icon className={className} weight={weight} />;
}
